import getters from "./getters"
// import socket from '@/core/services/socket';
import { 
  COMMIT_FETCH_MESSAGES,
  COMMIT_FETCH_USERS,
  COMMIT_UPDATE_MESSAGE,
  COMMIT_SET_USERS,
  COMMIT_ADD_VIEWED,
  TOGGLE_LOADING,
  COMMIT_FETCH_IMAGES,
  COMMIT_ADD_IMAGE,
  COMMIT_SET_IMAGES,
  HISTORY_MESSAGES
  } from '@/store/enums/mutations-types'
import ApiService from "@/core/services/ApiService";


const module = {
namespaced: true,
state(){
  return{
    messages:[],
    users: [],
    images: [], 
    gallery: [],
    sending: {
      status: false,
      type: ''
    },
    cant_messages: null,
    returned_messages: null
  }
},
getters,
mutations: {
  [COMMIT_FETCH_MESSAGES](state, payload){
    state.messages = payload
  },
  [COMMIT_FETCH_USERS](state, payload){
    state.users = payload
  },
  [COMMIT_FETCH_IMAGES](state, payload = state.gallery){
    
    payload.forEach(gallery => {
      gallery.images && state.images.push( gallery.images[0] )
    })
  },
  [COMMIT_ADD_IMAGE](state, payload){
    state.images.push(payload)
  },
  [COMMIT_UPDATE_MESSAGE](state, payload){
    if ((state.messages.length == 0) || (!!state.messages && (state.messages[state.messages.length - 1].id != payload.id))) {
      state.messages.push(payload);
      payload.images && state.images.push(payload.images[0])
    } else {
      // state.messages[state.messages.length - 1] = payload;
      console.log('🚀 es un id repetido')
    }
  },
  [COMMIT_SET_USERS](state, payload){
    state.users = payload
  },
  [COMMIT_SET_IMAGES](state, payload){
    state.images = payload
  },
  [COMMIT_ADD_VIEWED](state, payload){
    state.messages = state.messages.map(message => {
      if (message.id == payload.id){
        message.Viewed = payload.Viewed
      }
      return message
    })
  },
  [TOGGLE_LOADING](state, payload){
    state.sending = payload
  },
  [HISTORY_MESSAGES](state, payload){
    state.cant_messages = payload.cant_messages
    state.returned_messages = payload.returned_messages
  } 

},
actions: {
  async fetchMessages({commit, state, rootState, dispatch }, payload){
    let data
    
    if (payload.weeks == 1){
      data = await ApiService.get(`/chat/${payload.id}/users`)
      data = data.data
      dispatch('fetchImages', payload.id)
    }

    try {
      payload.weeks == 1 && commit(COMMIT_FETCH_USERS, data.data.users)
      const { data: data_messages } = await ApiService.get(`/chat/${payload.id}/messages/${payload.weeks || ''}`)

      commit(COMMIT_FETCH_MESSAGES, data_messages.data.messages)
      commit(HISTORY_MESSAGES, data_messages.data)
      if (payload.weeks == 1 && data_messages.data.messages) {
        // socket.emit('message', {
        //   type: 'channel',
        //   channel: payload.id, // Reemplaza '1' con el ID del canal adecuado
        //   data: state.messages[state.messages.length - 1]
        // });
      } 
      
      
    //  if (user.username){
    //   commit(COMMIT_SET_STATUS, 'active', {root: true})
    //   console.log('status', rootState.status)
    //  }

    } catch (error) {
      console.log('🚀 ~ fetchMessages ~ error', error)
      
    }

  },

  async fetchImages({commit, state, rootState}, payload){
    try {
      const { data } = await ApiService.get(`/chat/${payload}/images`)
      commit(COMMIT_FETCH_IMAGES, data.data.gallery)
    } catch (error) {
      console.log('🚀 ~ fetchImages ~ error', error)
    }
  },
  async sendMessages({commit, state, rootState}, payload){
    let formData = new FormData()
    
    formData.append('chat_id', payload.chat_id)
     if( payload.file){
      formData.append('images[]', payload.file)
    } else {
      formData.append('message', payload.message)
    }
    try {
      const { data } = await ApiService.post(`/chat/message/sent`, formData, true)

      // socket.emit('message', {
      //   type: 'channel',
      //   channel: payload.chat_id, // Reemplaza '1' con el ID del canal adecuado
      //   data: data.data
      // });
      commit(TOGGLE_LOADING, {status: false, type: ''})

    } catch (error) {
      console.log('🚀 ~ sendMessages ~ error', error)
      commit(TOGGLE_LOADING, {status: false, type: ''})
    }
  },
  async readMessages({commit, state, rootState}, payload){
    
    try {
      const { data } = await ApiService.post(`/chat/read-all-messages/${payload}`)
      // socket.emit('message', {
      //   type: 'channel',
      //   channel: payload, // Reemplaza '1' con el ID del canal adecuado
      //   data: data.data
      // });

    } catch (error) {
      console.log('🚀 ~ readMessages ~ error', error)
    }
  }
  
},

}
export default module